// ============================================================
// DNH — UN M49 continent & region taxonomy
// ISO 3166-1 alpha-2 → continent + UN M49 subregion lookup.
// Used by WorldMap for correct grouping (no bounding boxes).
// ============================================================

// 7 continents
export const CONTINENTS = {
  AS: { id: "AS", label: "Asia",          centroid: [85, 38] },
  AF: { id: "AF", label: "Africa",        centroid: [20, 5]  },
  EU: { id: "EU", label: "Europe",        centroid: [15, 55] },
  NA: { id: "NA", label: "North America", centroid: [-100, 45] },
  SA: { id: "SA", label: "South America", centroid: [-60, -15] },
  OC: { id: "OC", label: "Oceania",       centroid: [140, -25] },
  AN: { id: "AN", label: "Antarctica",    centroid: [0, -82] },
};

// 17 UN M49 subregions
export const REGIONS = {
  // Asia (5)
  "AS-E":  { id: "AS-E",  label: "Eastern Asia",       continent: "AS", centroid: [110, 38] },
  "AS-SE": { id: "AS-SE", label: "South-Eastern Asia", continent: "AS", centroid: [110, 5]  },
  "AS-S":  { id: "AS-S",  label: "Southern Asia",      continent: "AS", centroid: [78, 22]  },
  "AS-W":  { id: "AS-W",  label: "Western Asia",       continent: "AS", centroid: [45, 30]  },
  "AS-C":  { id: "AS-C",  label: "Central Asia",       continent: "AS", centroid: [65, 45]  },
  // Africa (2 — UN M49 splits into 5 but editorially 2 reads cleaner)
  "AF-N":  { id: "AF-N",  label: "Northern Africa",     continent: "AF", centroid: [18, 27]  },
  "AF-SS": { id: "AF-SS", label: "Sub-Saharan Africa",  continent: "AF", centroid: [22, -5]  },
  // Europe (4)
  "EU-N":  { id: "EU-N",  label: "Northern Europe",     continent: "EU", centroid: [15, 62]  },
  "EU-W":  { id: "EU-W",  label: "Western Europe",      continent: "EU", centroid: [5, 50]   },
  "EU-S":  { id: "EU-S",  label: "Southern Europe",     continent: "EU", centroid: [15, 42]  },
  "EU-E":  { id: "EU-E",  label: "Eastern Europe",      continent: "EU", centroid: [30, 52]  },
  // Americas (3)
  "NA-N":  { id: "NA-N",  label: "Northern America",    continent: "NA", centroid: [-100, 50] },
  "NA-C":  { id: "NA-C",  label: "Central America & Caribbean", continent: "NA", centroid: [-85, 18] },
  "SA-S":  { id: "SA-S",  label: "South America",       continent: "SA", centroid: [-60, -15] },
  // Oceania (3 — Aus/NZ + Melanesia + Micronesia/Polynesia merged for legibility)
  "OC-AN": { id: "OC-AN", label: "Australia & N. Zealand", continent: "OC", centroid: [140, -28] },
  "OC-M":  { id: "OC-M",  label: "Melanesia",            continent: "OC", centroid: [160, -10] },
  "OC-P":  { id: "OC-P",  label: "Micronesia & Polynesia", continent: "OC", centroid: [170, 5] },
  // Antarctica (1)
  "AN-A":  { id: "AN-A",  label: "Antarctica",           continent: "AN", centroid: [0, -82] },
};

// ISO alpha-2 → UN M49 subregion code
// Source: UN M49 standard country grouping, codified manually for Phase A.
export const ISO_TO_REGION = {
  // ===== Western Asia (Middle East + Caucasus + Cyprus + Turkey) =====
  AE: "AS-W", AM: "AS-W", AZ: "AS-W", BH: "AS-W", CY: "AS-W", GE: "AS-W",
  IL: "AS-W", IQ: "AS-W", JO: "AS-W", KW: "AS-W", LB: "AS-W", OM: "AS-W",
  PS: "AS-W", QA: "AS-W", SA: "AS-W", SY: "AS-W", TR: "AS-W", YE: "AS-W",
  // ===== Southern Asia =====
  AF: "AS-S", BD: "AS-S", BT: "AS-S", IN: "AS-S", IR: "AS-S", LK: "AS-S",
  MV: "AS-S", NP: "AS-S", PK: "AS-S",
  // ===== Eastern Asia =====
  CN: "AS-E", HK: "AS-E", JP: "AS-E", KP: "AS-E", KR: "AS-E", MO: "AS-E",
  MN: "AS-E", TW: "AS-E",
  // ===== South-Eastern Asia =====
  BN: "AS-SE", ID: "AS-SE", KH: "AS-SE", LA: "AS-SE", MM: "AS-SE", MY: "AS-SE",
  PH: "AS-SE", SG: "AS-SE", TH: "AS-SE", TL: "AS-SE", VN: "AS-SE",
  // ===== Central Asia =====
  KZ: "AS-C", KG: "AS-C", TJ: "AS-C", TM: "AS-C", UZ: "AS-C",

  // ===== Northern Africa =====
  DZ: "AF-N", EG: "AF-N", LY: "AF-N", MA: "AF-N", SD: "AF-N", SS: "AF-N",
  TN: "AF-N", EH: "AF-N",
  // ===== Sub-Saharan Africa =====
  AO: "AF-SS", BF: "AF-SS", BI: "AF-SS", BJ: "AF-SS", BW: "AF-SS", CD: "AF-SS",
  CF: "AF-SS", CG: "AF-SS", CI: "AF-SS", CM: "AF-SS", CV: "AF-SS", DJ: "AF-SS",
  ER: "AF-SS", ET: "AF-SS", GA: "AF-SS", GH: "AF-SS", GM: "AF-SS", GN: "AF-SS",
  GQ: "AF-SS", GW: "AF-SS", KE: "AF-SS", KM: "AF-SS", LR: "AF-SS", LS: "AF-SS",
  MG: "AF-SS", ML: "AF-SS", MR: "AF-SS", MU: "AF-SS", MW: "AF-SS", MZ: "AF-SS",
  NA: "AF-SS", NE: "AF-SS", NG: "AF-SS", RE: "AF-SS", RW: "AF-SS", SC: "AF-SS",
  SH: "AF-SS", SL: "AF-SS", SN: "AF-SS", SO: "AF-SS", ST: "AF-SS", SZ: "AF-SS",
  TD: "AF-SS", TG: "AF-SS", TZ: "AF-SS", UG: "AF-SS", YT: "AF-SS", ZA: "AF-SS",
  ZM: "AF-SS", ZW: "AF-SS", IO: "AF-SS",

  // ===== Northern Europe =====
  DK: "EU-N", EE: "EU-N", FI: "EU-N", IS: "EU-N", IE: "EU-N", LV: "EU-N",
  LT: "EU-N", NO: "EU-N", SE: "EU-N", GB: "EU-N", AX: "EU-N", FO: "EU-N",
  GG: "EU-N", IM: "EU-N", JE: "EU-N", SJ: "EU-N",
  // ===== Western Europe =====
  AT: "EU-W", BE: "EU-W", CH: "EU-W", DE: "EU-W", FR: "EU-W", LI: "EU-W",
  LU: "EU-W", MC: "EU-W", NL: "EU-W",
  // ===== Southern Europe =====
  AD: "EU-S", AL: "EU-S", BA: "EU-S", ES: "EU-S", GI: "EU-S", GR: "EU-S",
  HR: "EU-S", IT: "EU-S", ME: "EU-S", MK: "EU-S", MT: "EU-S", PT: "EU-S",
  RS: "EU-S", SI: "EU-S", SM: "EU-S", VA: "EU-S",
  // ===== Eastern Europe =====
  BG: "EU-E", BY: "EU-E", CZ: "EU-E", HU: "EU-E", MD: "EU-E", PL: "EU-E",
  RO: "EU-E", RU: "EU-E", SK: "EU-E", UA: "EU-E",

  // ===== Northern America =====
  BM: "NA-N", CA: "NA-N", GL: "NA-N", PM: "NA-N", US: "NA-N",
  // ===== Central America & Caribbean =====
  AG: "NA-C", AI: "NA-C", AW: "NA-C", BB: "NA-C", BL: "NA-C", BQ: "NA-C",
  BS: "NA-C", BZ: "NA-C", CR: "NA-C", CU: "NA-C", CW: "NA-C", DM: "NA-C",
  DO: "NA-C", GD: "NA-C", GP: "NA-C", GT: "NA-C", HN: "NA-C", HT: "NA-C",
  JM: "NA-C", KN: "NA-C", KY: "NA-C", LC: "NA-C", MF: "NA-C", MQ: "NA-C",
  MS: "NA-C", MX: "NA-C", NI: "NA-C", PA: "NA-C", PR: "NA-C", SV: "NA-C",
  SX: "NA-C", TC: "NA-C", TT: "NA-C", VC: "NA-C", VG: "NA-C", VI: "NA-C",

  // ===== South America =====
  AR: "SA-S", BO: "SA-S", BR: "SA-S", CL: "SA-S", CO: "SA-S", EC: "SA-S",
  FK: "SA-S", GF: "SA-S", GY: "SA-S", GS: "SA-S", PE: "SA-S", PY: "SA-S",
  SR: "SA-S", UY: "SA-S", VE: "SA-S",

  // ===== Australia & New Zealand =====
  AU: "OC-AN", NZ: "OC-AN", CC: "OC-AN", CX: "OC-AN", HM: "OC-AN", NF: "OC-AN",
  // ===== Melanesia =====
  FJ: "OC-M", NC: "OC-M", PG: "OC-M", SB: "OC-M", VU: "OC-M",
  // ===== Micronesia & Polynesia =====
  AS: "OC-P", CK: "OC-P", FM: "OC-P", GU: "OC-P", KI: "OC-P", MH: "OC-P",
  MP: "OC-P", NR: "OC-P", NU: "OC-P", PF: "OC-P", PN: "OC-P", PW: "OC-P",
  TK: "OC-P", TO: "OC-P", TV: "OC-P", WF: "OC-P", WS: "OC-P", UM: "OC-P",

  // ===== Antarctica =====
  AQ: "AN-A", TF: "AN-A",
};

// Derive ISO alpha-2 → continent from region map
export const ISO_TO_CONTINENT = Object.fromEntries(
  Object.entries(ISO_TO_REGION).map(([iso, region]) => [iso, REGIONS[region].continent])
);

// Mock signal counts per continent and per region (Phase A static).
// In Phase B these come from /api/today?groupBy=continent|region.
export const CONTINENT_SIGNAL_COUNTS = {
  AS: 89,
  EU: 47,
  AF: 14,
  NA: 38,
  SA: 9,
  OC: 6,
  AN: 0,
};

export const REGION_SIGNAL_COUNTS = {
  "AS-W":  18,
  "AS-S":  32,
  "AS-E":  24,
  "AS-SE": 11,
  "AS-C":  4,
  "AF-N":  6,
  "AF-SS": 8,
  "EU-N":  13,
  "EU-W":  18,
  "EU-S":  9,
  "EU-E":  7,
  "NA-N":  31,
  "NA-C":  7,
  "SA-S":  9,
  "OC-AN": 5,
  "OC-M":  1,
  "OC-P":  0,
  "AN-A":  0,
};
